<template>
  <div class="info-card">
    <div class="info-card__item" v-for="({title, subtitle, image = false}, i) in attributes" :key="i">
      <div class="info-card__item--container">
        <div class="title">
          {{title}}
        </div>
        <template v-if="typeof subtitle == 'object'">
          <div class="d-flex">
            <div class="subtitle ml-1" v-for="(title, i) in subtitle" :key="'t'+i">
              {{title}}
            </div>
          </div>
        </template>
        <div class="subtitle off" v-else>
          {{subtitle}}
        </div>
      </div>
      <img v-if="image" :src="image"/>
    </div>
  </div>
</template>

<script>
export default {
  name: "card-info",
  data: ()=> ({
    info: [
      {
        title: 'Бренд',
        subtitle: ['Удочки и спининг'],
        image: require ( '../../assets/img/item/logo.png' )
      },
      {
        title: 'Технология',
        subtitle: ['Гортекс','Инстаклик']
      },
      {
        title: 'Штрих-код производителя',
        subtitle: '453244343424'
      },
      {
        title: 'Артикул продавца',
        subtitle: '4239823524555'
      },
      {
        title: 'Поставка',
        subtitle: 'За счет поставщика'
      },
      {
        title: 'Гарантия',
        subtitle: '12 месяцев'
      },
      {
        title: 'Производитель',
        subtitle: 'Черный склад'
      },
      {
        title: 'Страна происхождения',
        subtitle: 'Россия'
      },
      {
        title: 'Код ТН ВЭД',
        subtitle: '34500 000'
      },
    ],
    attributes: []
  }),
  props: {
    item: null
  },
  mounted() {
    if (this.item.attributes != null) {
      for (let key1 in this.info) {
        for (let key2 in this.item.attributes) {
          if (this.info[key1].title == this.item.attributes[key2].attribute.name) {
            this.attributes.push({
              title: this.info[key1].title,
              subtitle: this.item.attributes[key2].value.value
            });
          }
        }
      }

      this.attributes.push({
        title: 'Артикул производителя:',
        subtitle: this.item.article,
      });

    }
  }
}
</script>

<style scoped lang="scss">
.info-card {
  background-color: #EEF0F3;
  border-radius: 4px;
  padding: 18px 30px;

&__item{
   height: 45px;
   margin-top: .5em;
   border-bottom: 1px solid #D5D9E0;
   font-family: Roboto;
   font-style: normal;
   font-weight: normal;
   display: flex;
   justify-content: space-between;
   align-items: center;

&--container {
.title{
  color: #000;
  font-size: 11px;
  line-height: 13px;
  margin-bottom: .7em;
}
.subtitle{
  color: #7A818F;
  font-size: 14px;
  line-height: 16px;
  text-decoration-line: underline;
}
.off{
  text-decoration-line: none;
}
}
img {
  width: 45px;
  height: 30px;
}
}

}
</style>